module.exports = __webpack_public_path__ + "media/images/webpage/hotels/theme/cover-heading-kyoto-f94228d6536b6167e0922f019d86155b.svg";